import {
  Call,
  CallDirection,
  CallState,
} from "@redotech/redo-model/support/voice/voice-types";
import { memo } from "react";
import { Flex } from "../flex";
import { Text } from "../text";
import { UserImage, UserImageSize } from "../user-image";
import { TimeElapsed } from "./active-call-elapsed-time";

export const CallProgressView = memo(function CallProgressView({
  call,
}: {
  call: Call;
}) {
  const text = call.customer.name
    ? `${call.customer.name} - ${call.remoteCallerNumber}`
    : call.remoteCallerNumber;

  return (
    <Flex align="center" dir="column">
      <UserImage
        alt={call.customer.name || call.remoteCallerNumber}
        imageUrl={null}
        size={UserImageSize.MEDIUM_SMALL}
      />
      <Text fontSize="xxs" textColor="secondary">
        {text}
      </Text>
      {call.state === CallState.ACTIVE ? (
        <TimeElapsed startTime={call.startTime} />
      ) : (
        <CallText call={call} />
      )}
    </Flex>
  );
});

export function getCallText(call: Call): string {
  if (call.direction === CallDirection.OUTBOUND) {
    switch (call.state) {
      case CallState.CONNECTING:
        return "Connecting...";
      case CallState.RINGING:
        return "Calling...";
      case CallState.HANGUP:
        return "Call ended";
      default:
        return "";
    }
  } else {
    switch (call.state) {
      case CallState.RINGING:
        return "Incoming call...";
      case CallState.CONNECTING:
        return "Connecting...";
      case CallState.HANGUP:
        return "Call ended";
      default:
        return "";
    }
  }
}

const CallText = memo(function CallText({ call }: { call: Call }) {
  return (
    <Text fontSize="xxs" textColor="primary">
      {getCallText(call)}
    </Text>
  );
});
